import React from 'react';

import { FilterField, InfoItem, RelatedContentModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import { formatNotFoundError } from '@utils';
import { FILTER_TYPE } from '@api/filters/constants';

const RelatedMedicalCare = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add a Medical Care"
    okText="ADD A MEDICAL CARE"
    onSubmit={({ entity }) => onSubmit(entity)}
  >
    <FilterField
      name="entity"
      label="Choose a medical care:"
      queryVariables={{ typeId: FILTER_TYPE.MEDICAL_CARE.id }}
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'Medical care is required' }]}
    />
  </RelatedContentModal>
);

const Item = (entity) => {
  if (entity instanceof Error) {
    const error = entity;
    return <InfoItem>{formatNotFoundError({ error })}</InfoItem>;
  }

  return <InfoItem>{entity.title}</InfoItem>;
};

RelatedMedicalCare.Item = Item;

export default RelatedMedicalCare;
